import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <main className="bg-paper pt-16">
      <Contact map />
    </main>
  );
}
